import { Outlet } from 'react-router-dom';

import moment from 'moment-timezone';
import { useEffect } from 'react';
import { AsideMenu } from '../components/AsideMenu';
import { Header } from '../components/Header';
import { useSidebar } from '../context/SidebarContext';
import { AppContainer } from './style';

const App = () => {
  const { sidebar } = useSidebar();


  useEffect(() => {
    moment.tz.setDefault('America/Sao_Paulo');
  }, []);

  return (
    <AppContainer sidebar={sidebar}>
      <AsideMenu />
      <main>
        <Header />
        <Outlet />
      </main>
    </AppContainer>
  );
};

export default App;
